<template lang="pug">
.welfare-container
  img.close-btn(src='@/assets/imgs/vip/ic_close.png' @click='closeVipWelfare')
  .banner
    img(src="@/assets/imgs/vip/light/welfare-bg.png")
    .content(v-if="welfareTotal > 0")
      .content-one.color_text_vip_2 你还有{{welfareTotal}}个福利未领取，
      .content-two
        span.color_text_vip_2 价值
        span.price ￥{{welfareWorth}}
  .welfare-loading.color_bg_3(v-if="loading")
    .content
      .loading-icon()
  .welfare-list.color_bg_3(v-if="welfareList.length > 0 && !loading")
    .welfare-list-inner
      .welfare-item(v-for="(item, index) in welfareList" :key="index")
        img.welfare-item-icon(:src="item.welfareType === 0 ? require('@/assets/imgs/vip/light/walfare_icon0.png') : item.welfareType === 1 ? require('@/assets/imgs/vip/light/walfare_icon1.png') : require('@/assets/imgs/vip/light/walfare_icon2.png')")
        .welfare-item-name.color_text_vip_2 {{item.planName}}
        .welfare-item-rightsType.color_text_vip_2 {{item.rightsType}}
        .welfare-item-price
          span.unit ￥
          span {{item.price}}
        .welfare-item-desc.color_text_vip_2
          span(v-if="item.welfareType === 2") {{item.obtainStatus === 0 ? `该福利需要在${timeFormat(item.activeTime)}前领取` : '该福利已领取'}}
          span(v-else-if="item.welfareType === 0") 该福利已在{{timeFormat(item.activeTime)}}发放
          span(v-else) 该福利已在{{timeFormat(item.activeTime)}}发放
        .welfare-item-operation
          .button.color_main_vip_1.color_text_vip_1(v-if="item.welfareType === 2 && (item.obtainStatus === 1 || item.activeStatus !== 0)" @click="goToVipWelfareView(item.planId, item.id, item.distributeType)") {{item.obtainStatus === 0 ? '去领取' : '去查看'}}
          .button.color_main_vip_1.color_text_vip_1(v-if="item.welfareType === 0" @click="buyRecharge") 去查看
  noWelfare(v-else)
</template>
<script>
import service from '@/service/vip';
import util from '@/util/index';
import serviceLogin from '@/service/login';
import noWelfare from './noWelfare.vue';

const welfareUrl = process.env.VUE_APP_WELFARE_URP;

export default {
  data() {
    return {
      welfareList: [],
      welfareTotal: 0,
      welfareWorth: 0,
      yduserid: '',
      loading: true,
    };
  },
  components: {
    noWelfare,
  },
  mounted() {
    this.getWelfareList();
    this.getAccountInfo();
  },
  methods: {
    buyRecharge() {
      this.$emit('openMorePackage');
      this.closeVipWelfare();
    },
    closeVipWelfare() {
      this.$emit('closeVipWelfare');
    },
    // 获取用户信息
    getAccountInfo() {
      serviceLogin.getAccountInfos().then((res) => {
        if (res.code === 0) {
          this.yduserid = res.data.yduserid;
        } else {
          this.yduserid = '';
        }
      }).catch((e) => {
        console.log('获取账户信息失败', e);
      });
    },
    timeFormat(time) {
      return util.formatTimeToYMD(time);
    },
    getWelfareList() {
      service.getWelfareList().then((res) => {
        this.welfareList = res.data.welfareList;
        this.welfareTotal = res.data.welfareTotal;
        this.welfareWorth = res.data.welfareWorth;
        this.loading = false;
      });
    },
    goToVipWelfareView(planId, id, type) {
      const url = `${welfareUrl}getWelfare?planId=${planId}&id=${id}&type=${type}&userid=${this.yduserid}`;
      window.open(url);
    },
  },
};
</script>
<style lang="stylus" scoped>
.welfare-container
  height 480px
  width 653px
  position fixed
  top 50%
  transform translate(-50%,-50%)
  left 50%
  z-index 99
  overflow: hidden
  padding-top 32px
  background: #FFF4E8
  border-radius 8px 8px 0 0
  .close-btn
    position absolute
    right 10px
    top 8px
    width 16px
    height 16px
    cursor pointer
  .banner
    width 100%
    // background: pink
    position relative
    img
      display: block
      width 100%
    .content
      position: absolute
      top 64px
      left 40px
    .content-one, .content-two
      display: inline-block
    .content-one
      font-size 16px
      line-height 12px
    .content-two
      font-size 16px
      position relative
      z-index 1
      .price
        font-size 18px
        font-weight 700
        color #FF7C5F
        vertical-align: middle
        font-family 'Gilroy'
    .content-two::before
      z-index -10
      content: ''
      position: absolute
      width 100%
      height 9px
      bottom -1px
      left 0
      border-radius 20px
      background: linear-gradient(90deg, #FFC2B5 5%, rgba(255,214,191,0.00) 99%, rgba(255,214,191,0.00) 137%)
  .welfare-loading
    width 100%
    height calc(100% - 92px)
    border-top-left-radius: 16px
    border-top-right-radius: 16px
    position relative
    top -26px
    .content
      width fit-content
      height fit-content
      position: absolute
      top 0
      left 0
      right 0
      bottom 0
      margin auto
      .loading-icon
        width 36px
        height 36px
        background url('../assets/imgs/vip/light/welfare-loading.gif') 0 0 /100% 100% no-repeat
        display block
        margin 0 auto
  .welfare-list
    border-top-left-radius: 16px
    border-top-right-radius: 16px
    position relative
    top -26px
    padding 16px 5px 16px 40px
    height: 356px
    .welfare-list-inner
      overflow-y scroll
      overflow-x hidden
      height 100%
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE 10+ */
      overflow: -moz-scrollbars-none; /* Firefox */
      &::-webkit-scrollbar
        width 3px
        background transparent
      &::-webkit-scrollbar-thumb
        width 3px
        height 89px
        background #E6E7E8
        border-radius 7px
      &::-webkit-scrollbar-track
        display none
    .welfare-item
      height 50px
      display: flex
      align-items: center
      .welfare-item-icon
        width 14px
        height 14px
        display: block
        margin-right 4px
      .welfare-item-name
        width 100px
        overflow: hidden
        font-size 12px
        line-height: 150%
      .welfare-item-rightsType
        font-size 12px
        width 80px
        text-align: left
        margin-left 20px
      .welfare-item-price
        width 50px
        text-align: left
        color: #FF7C5F
        font-size 15px
        font-family 'Gilroy'
        font-weight 500
        .unit
          font-weight 700
          font-size 13px
      .welfare-item-desc
        width 215px
        text-align: left
        margin-left 20px
        font-size 12px
      .welfare-item-operation
        .button
          width 60px
          height 28px
          line-height 28px
          text-align: center
          border-radius: 100px
          cursor pointer
          font-size 12px
</style>
